import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.lightBlue,
  },
  flex1: {
    flex: 1,
  },
  emptyBackground: {
    flex: 1,
    backgroundColor: theme.colors.lightBlue,
  },
});
